import moment from "moment";
import { httpClient } from "../../helpers/httpClient";
import {
  APP_API_URL,
  APP_API_VERSION,
  APP_URL,
  APP_NAME
} from "../../helpers/configuration";
import appBridge from "../../helpers/appBridge";

export default {
  redeemFreeCredit({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}:creditRedeem`;
    return httpClient
      .post(
        url,
        {
          amount: {
            currencyCode: "USD",
            units: JSON.parse(
              rootState.store.eligibleCredit
                ? rootState.store.eligibleCredit.units
                : ""
            ),
            nanos: 0
          }
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Redeem error" }, { root: true });
        console.log(error);
      });
  },
  getStoreBalance({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}:getBalance`;
    return httpClient
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setStoreBalance", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  topUp({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}:charge`;
    let param = "";
    if (payload.param) {
      param = `?campaign=${payload.param}`;
    }
    return httpClient
      .post(
        url,
        {
          amount: {
            currencyCode: "USD",
            units: JSON.parse(payload.amount),
            nanos: 0
          },
          redirectUrl: `${rootState.store.onlineShopUrl}admin/apps/${APP_NAME}${param}`
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        appBridge(rootState.store).redirectTo(res.data.confirmationUrl);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        commit("setError", { data: "Topup error" }, { root: true });
        console.log(error);
      });
  },
  resetReports({ commit }, payload) {
    commit("resetReports", "");
    return "";
  },
  getReport({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    let parameters = "";
    let params = {};
    if (payload.nextPageToken) {
      parameters = parameters + `&page_token=${payload.nextPageToken}`;
    }
    if (payload.dimension) {
      parameters = parameters + `&dimension=${payload.dimension}`;
    }

    if (payload.dateRange) {
      params = {
        "startDate.year": payload.dateRange.startDate.year,
        "startDate.month": payload.dateRange.startDate.month,
        "startDate.day": payload.dateRange.startDate.day,
        "endDate.year": payload.dateRange.endDate.year,
        "endDate.month": payload.dateRange.endDate.month,
        "endDate.day": payload.dateRange.endDate.day
      };
    }

    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}/${payload.endpoint}?page_size=40${parameters}`;
    httpClient
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        params
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit(payload.mutation, res.data);
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getStoreReport({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.enfonicaAccessToken;
    const url = `${APP_API_URL}${APP_API_VERSION}/${storeName}:generateOverviewReport`;
    return httpClient
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setStoreReport", res.data);
        return res.data;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getOrders({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.shopifyAccessToken;
    return httpClient
      .get(
        `${APP_URL}/orders?shopifyUrl=${storeName.slice(
          7
        )}&token=${accessToken}`
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        commit("setOrders", res.data);
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getOrderCount({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.shopifyAccessToken;
    const d = new Date();
    d.setMonth(d.getMonth() - 3);

    return httpClient
      .get(
        `${APP_URL}/graphql` +
          `?shopifyUrl=https://${storeName.slice(
            7
          )}/admin/api/2022-10/orders/count.json?created_at_min=${d.toISOString()}&fulfillment_status=shipped&token=${accessToken}`
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        // @ts-ignore
        commit("setOrderCount", res.data.count);
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getCustomerCount({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.shopifyAccessToken;
    return httpClient
      .get(
        `${APP_URL}/graphql` +
          `?shopifyUrl=https://${storeName.slice(
            7
          )}/admin/api/2022-10/customers/count.json&token=${accessToken}`
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        // @ts-ignore
        commit("setCustomerCount", res.data.count);
        return res.data.count;
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getSubscriberCount({ commit, state, rootState }, payload) {
    commit("setLoadingSubs", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.shopifyAccessToken;
    return httpClient
      .get(
        `${APP_URL}/subscribers?shopifyUrl=${storeName.slice(
          7
        )}&token=${accessToken}`
      )
      .then(res => {
        console.log(res);
        if (res.data.code === "ETIMEDOUT") {
          commit("setLoadingSubs", false, { root: true });
          commit("setLoadingSubsFailed", false, { root: true });
          return;
        }
        commit("setLoadingSubs", false, { root: true });
        // @ts-ignore
        commit("setSubscriberCount", res.data.length);
      })
      .catch(error => {
        commit("setLoadingSubs", false, { root: true });
        commit("setLoadingSubsFailed", false, { root: true });
        console.log(error.data);
      });
  },
  getShippingCountries({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.shopifyAccessToken;
    return httpClient
      .get(
        `${APP_URL}/graphql` +
          `?shopifyUrl=https://${storeName.slice(
            7
          )}/admin/api/2022-10/countries.json&token=${accessToken}`
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        const countries = res.data.countries;
        const mappedCountries = [];
        countries.map(country => {
          const mappedCountry = {
            text: country.name,
            value: JSON.stringify(country.id)
          };
          mappedCountries.push(mappedCountry);
        });
        commit("setShippingCountries", mappedCountries);
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  },
  getExistingDiscounts({ commit, state, rootState }, payload) {
    commit("setLoading", true, { root: true });
    const storeName = rootState.store.name;
    const accessToken = rootState.store.shopifyAccessToken;
    const query = `{
      codeDiscountNodes(first: 100) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            codeDiscount {
              __typename
              ... on DiscountCodeBasic {
                title
                codeCount
                codes(first: 2){
                  edges {
                    node {
                      code
                    }
                  }
                }
              }
              
              ... on DiscountCodeBasic {
                title
                codeCount
                codes(first: 2){
                  edges {
                    node {
                      code
                    }
                  }
                }
              }
              
              ... on DiscountCodeFreeShipping {
                title
                codeCount
                codes(first: 2){
                  edges {
                    node {
                      code
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    `;
    return httpClient
      .get(
        `${APP_URL}/graphql` +
          `?shopifyUrl=https://${storeName.slice(
            7
          )}/admin/api/2022-10/graphql.json&query=${query}&token=${accessToken}`
      )
      .then(res => {
        commit("setLoading", false, { root: true });
        const basicDiscounts = [];
        const discounts = res.data.data.codeDiscountNodes.edges;
        discounts.map(discount => {
          if (
            discount.node.codeDiscount.codeCount === 1 &&
            discount.node.codeDiscount.title ===
              discount.node.codeDiscount.codes.edges[0].node.code
          ) {
            const n = discount.node.id.lastIndexOf("/");
            const result = discount.node.codeDiscount.codes.edges[0].node.code;

            const mappedDiscount = {
              text: discount.node.codeDiscount.title,
              value: result
            };
            return basicDiscounts.push(mappedDiscount);
          }
        });
        commit("setExistingDiscounts", basicDiscounts);
      })
      .catch(error => {
        commit("setLoading", false, { root: true });
        console.log(error);
      });
  }
};
